export default {
	width: 0,
	height: 0,
}
	
